import { render, staticRenderFns } from "./star.vue?vue&type=template&id=d0cfe1dc&scoped=true&"
import script from "./star.vue?vue&type=script&lang=js&"
export * from "./star.vue?vue&type=script&lang=js&"
import style0 from "./star.vue?vue&type=style&index=0&id=d0cfe1dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cfe1dc",
  null
  
)

export default component.exports